export class ListData {
    canAdd!: boolean;
    pageIndex!: number;
    totalCount!: number;
    pageSize!: number;
    restaurantName!: string
    pageData!: {
      canDelete: boolean
      canEdit: boolean
      created: string
      id: string
      title_EN: string
      title_AR: string
      numberOfUse: number
    }[];
  }
  
  export class Record {
    id!: string
    title_EN!: string
    title_AR!: string
    restaurantId!: number;
  }
  
  export class ListFilter {
    pageSize!: number;
    pageNumber!: number;
    sortItems!: sortList;
    searchText!: string;
    createdFrom!: Date;
    createdTo!: Date;
    restaurantId!: number;
    numberOfItemfrom!: number;
    numberOfItemto!: number;
  }
  
  export enum sortList {
    Name = 0,
    NewestCreate = 1,
    OldestCreate = 2,
    HighestUse = 4,
    LowestUse = 3
  }
  